import { render, staticRenderFns } from "./a-loader.vue?vue&type=template&id=e6274ee8&"
import script from "./a-loader.vue?vue&type=script&lang=js&"
export * from "./a-loader.vue?vue&type=script&lang=js&"
import style0 from "./a-loader.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports